<template>
  <div class="popup-form">
    <div class="content-form-popup">
      <div class="header-text">
        <button type="button" class="back-button-wrapper pointer close-button" @click="closePopup">
          ×
        </button>
        <div class="blackcolor pop-800">Prehraná hypotéka</div>
        <button class="w-button saveformBtn" form="prehranaForm" :disabled="disabled">
          Uložiť
        </button>
      </div>

      <form class="mt-8" id="prehranaForm" @submit.prevent="savePrehranaForm">
        <div class="input-group">
          <v-textarea
            outlined
            required
            name="moveToPrehrana"
            label="Prečo bol obchod prehratý?"
            v-model="reasonOfAction"
          />
        </div>
        <div class="methodology-hint">
          Použite pri obchode, ktorý klient realizoval inde alebo od riešenia definitívne odišiel.
          Archivácia klienta používa samostatný stav „Zrušená“.
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "HypotekyDialogPrehrana",
  props: {
    payload: Object,
  },
  computed: {
    disabled() {
      return !this.reasonOfAction.trim();
    },
  },
  data() {
    return {
      reasonOfAction: "",
    };
  },
  methods: {
    async savePrehranaForm() {
      await this.$store.dispatch("mortgagesState/moveMortgageToDifferentStage", {
        ...this.payload,
        dovod_prehratia: this.reasonOfAction.trim(),
        stage_old: this.payload.stage,
        stage: "prehrana",
      });
      this.closePopup();
    },
    closePopup() {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
  },
};
</script>

<style scoped lang="scss">
.close-button {
  border: 0;
  background: transparent;
  color: var(--app-primary, #2d7dd2);
  font-size: 28px;
}

.methodology-hint {
  margin-top: 14px;
  padding: 12px 14px;
  border-radius: 12px;
  background: var(--app-surface-muted, #f4f8fc);
  color: var(--app-text-muted, #6f7f96);
  font-size: 12px;
  line-height: 1.45;
}

.saveformBtn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
</style>
